import { makeAutoObservable, observable, toJS } from 'mobx';

import {
  ComplimentNotification,
  Notification,
  VisitNotification,
} from './types';

/**
 * Class dedicated to move store messages and manage them from Notifications component
 */
class NotificationStore {
  messages = observable.array<Notification>();

  constructor() {
    makeAutoObservable(this);
  }

  getRawMessages() {
    return toJS(this.messages);
  }

  addComplimentNotification(payload: ComplimentNotification['payload']) {
    const message: ComplimentNotification = {
      id: String(Date.now()),
      type: 'compliment',
      payload,
    };
    this.messages.push(message);
  }

  addVisitNotification(payload: VisitNotification['payload']) {
    const message: VisitNotification = {
      id: String(Date.now()),
      type: 'visit',
      payload,
    };
    this.messages.push(message);
  }

  removeMessage(message: Notification) {
    this.messages.remove(message);
  }

  clear() {
    this.messages.clear();
  }
}

const notificationStore = new NotificationStore();
export default notificationStore;
